<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '../utils';
    import { Separator } from '../Separator';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <Separator
        data-slot="sidebar-separator"
        data-sidebar="separator"
        :class="cn('bg-sidebar-border w-auto my-2', props.class)"
    >
        <slot />
    </Separator>
</template>
